import React from "react"

import Header from "../parts/Header"
import HeaderMember from "../parts/HeaderMember"
import AuthActions from '../../actions/AuthActions';
import MemberActions from '../../actions/MemberActions';
import MemberStore from '../../stores/MemberStore'
import AuthStore from '../../stores/AuthStore'



export default class PaidApp extends React.Component {

  constructor(){
    super()
    this.paidListChangeHandler = this.paidListChangeHandler.bind(this)
    AuthActions.setAuth()
    this.state = {
      item:null,
      paid_list:[]
    }
  }

  componentDidMount(){
    MemberStore.addChangeListener(this.paidListChangeHandler,"paid_list")
    MemberActions.getPaidList(AuthStore.getToken())

  }


  componentWillUnmount(){
    MemberStore.removeChangeListener(this.paidListChangeHandler,"paid_list")


  }

  paidListChangeHandler(){
    this.setState({
      paid_list:MemberStore.getPaidList()
    })
  }





  render(){

    const paid_list = this.state.paid_list.map((item) => {
      var status_html = "エラー"
      var date = new Date(item.created * 1000)
      if(item.paid){
        status_html = "支払い済"
      }
      return <tr><td>{date.getFullYear() + "年" + (date.getMonth() + 1) + "月" + date.getDate()  +"日"}</td><td>{item.amount.toLocaleString()}円</td><td>{status_html}</td></tr>
    })
    return(
      <div>
      <HeaderMember />
      <main>
        <Header />

        <div className="main-pannel">
        <h1>月会費お支払い履歴</h1>
        <section>
          <table className="paid_list">
            <tr><th>日付</th><th>金額</th><th>ステータス</th></tr>
            {paid_list}
          </table>
        </section>
        </div>
      </main>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/member/PaidApp.js